import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { StreamerDB } from "./StreamerDB";

export class StreamerDBElement
{
  static readonly type = new ElementType( "streamer-db" );
  
  
  static applyOnDocument()
  {
    StreamerDBElement.type.forAllInDoc( e => StreamerDBElement.applyOnElement( e ) );
  }

  static applyOnElement( e:Element ) 
  {
    let streamerDB = new StreamerDB();
    streamerDB.initialize( e ) ;
  }
}